import { ColumnSortType, TableColumnTypes } from '../../../../model/table.model';

export const tableHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox'
  },
  {
    value: 'planner_name',
    sort: ColumnSortType.NONE,
    name: 'olx.planners.planner_name',
    type: TableColumnTypes.TITLE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'advert_id',
    sort: ColumnSortType.NONE,
    name: 'ID',
    type: TableColumnTypes.TEXT_COPY,
    className: 'table-header',
    disabled: true,
  },
    {
    value: 'advert_name',
    sort: ColumnSortType.NONE,
    name: 'olx.planners.advert_name',
    type: TableColumnTypes.TITLE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.PLANNER_STATUS,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'type_planner',
    sort: ColumnSortType.NONE,
    name: 'type',
    type: TableColumnTypes.PLANNER_TYPE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'created_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'planned_at',
    sort: ColumnSortType.NONE,
    name: 'run_at',
    type: TableColumnTypes.DATETIME,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'reason',
    sort: ColumnSortType.NONE,
    name: 'reason_error',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    translate: true,
    actions:
      [
        { icon: 'manage_history', label: 'change_advert', value: 'CHANGE_ADVERT', color_icon: 'green' },
        // { icon: 'manage_history', label: 'change_planning', value: 'UPDATE_PLANNER', color_icon: 'green' },
        { icon: 'manage_history', label: 'to_draft', value: 'TO_DRAFT', color_icon: 'green' },
        { icon: 'manage_history', label: 'to_active', value: 'TO_ACTIVE', color_icon: 'green' },
        // { icon: 'replay', label: 're_planning', value: 'REPLAN_PLANNER', color_icon: 'gray' },
        { icon: 'delete', label: 'cancel_planning', value: 'CANCEL_PLANNER', color_icon: 'red' },
      ]
  },
];
